<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="approveDialogVisible"
    width="40%"
    class="agreeDialog"
  >
    <el-form class="common_form" label-position="left" ref="agreeDialogForm" :rules="rules" label-width="180px" :model="formData">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('approvalCenter.AppCom')">
            <el-input type="textarea" v-model="formData.reason" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="approveDialogVisible = false">{{ $t('btn.Cancel') }}</el-button>
      <el-button type="primary" @click="subBtn">{{ $t('btn.OK') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      rules: {
        directors: [
          { required: true, message: this.$t('approvalCenter.Psaem'), trigger: 'blur' }
        ],
        reason: [
          { required: true, message: this.$t('approvalCenter.Peac'), trigger: 'blur' }
        ]
      },
      approveDialogVisible: false,
      formData: {
        reason: ''
      },
      dialogTitle: '同意'
    };
  },
  methods: {
    init (parameter) {
      const { type, visible } = parameter;
      this.dialogTitle = type;
      this.approveDialogVisible = visible;
      this.formData.reason = type;
    },
    subBtn () {
      this.$refs['agreeDialogForm'].validate((valid) => {
        if (valid) {
          this.$emit('approveSubHandle', {
            reason: this.formData.reason,
            type: this.dialogTitle
          });
          this.approveDialogVisible = false;
        }
      });
    }
  }
};
</script>
